<script setup>
// El dibujo de un servicio. Mismo trazo que el resto de los íconos de la
// página: 24×24, sin relleno, línea de una y media y las puntas redondeadas.
//
// Vive en el bundle y no como archivo subido: son cinco dibujos que tienen que
// verse como una familia, y eso no se consigue con lo que cada uno suba.
defineProps({
  name: { type: String, default: 'general' }
})
</script>

<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <!-- Instalar es dejar la cortina colgada del muro: la línea de arriba es el
         muro, las dos patas son los soportes y abajo cuelga la tela. Un taladro
         suelto no dice qué se instala; esto sí. -->
    <template v-if="name === 'install'">
      <path d="M2.5 3h19" />
      <path d="M7 3v2.2M17 3v2.2" />
      <rect x="4.5" y="5.2" width="15" height="3.2" rx="1.6" />
      <path d="M5.8 8.4v10.2c2.05 1.5 4.15 1.5 6.2 0s4.15-1.5 6.2 0V8.4" />
    </template>

    <!-- La llave inglesa: la cabeza abierta arriba y el mango en diagonal. -->
    <template v-else-if="name === 'repair'">
      <path
        d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.8-3.8a6 6 0 0 1-7.9 7.9
           l-6.9 6.9a2.1 2.1 0 0 1-3-3l6.9-6.9a6 6 0 0 1 7.9-7.9z"
      />
    </template>

    <!-- El engranaje lleva su contorno: sin él, ocho rayas alrededor de un
         círculo son un sol y no una pieza que se ajusta. -->
    <template v-else-if="name === 'maintenance'">
      <circle cx="12" cy="12" r="7.2" />
      <circle cx="12" cy="12" r="2.6" />
      <path
        stroke-width="2"
        d="M19.2 12h2.3M17.1 17.1l1.6 1.6M12 19.2v2.3M6.9 17.1l-1.6 1.6M4.8 12H2.5
           M6.9 6.9 5.3 5.3M12 4.8V2.5M17.1 6.9l1.6-1.6"
      />
    </template>

    <!-- La gota cayendo sobre la tela mojada. -->
    <template v-else-if="name === 'wash'">
      <path d="M12 2.5c3.5 3.9 5.3 6.6 5.3 8.6a5.3 5.3 0 0 1-10.6 0c0-2 1.8-4.7 5.3-8.6z" />
      <path d="M2.5 18.5c1.6-1.6 3.2-1.6 4.8 0s3.2 1.6 4.8 0 3.2-1.6 4.8 0 3.2 1.6 4.6 0" />
      <path d="M2.5 22c1.6-1.6 3.2-1.6 4.8 0s3.2 1.6 4.8 0 3.2-1.6 4.8 0 3.2 1.6 4.6 0" />
    </template>

    <!-- El comodín, para un servicio que no sea ninguno de los cuatro. -->
    <template v-else>
      <path d="M11 2.8 13.1 8.4 18.7 10.5 13.1 12.6 11 18.2 8.9 12.6 3.3 10.5 8.9 8.4z" />
      <path d="M18 16.4 18.8 18.6 21 19.4 18.8 20.2 18 22.4 17.2 20.2 15 19.4 17.2 18.6z" />
    </template>
  </svg>
</template>
